import { adminServerInstance } from "../axios/instances";

import { WAREHOUSE_LOAD, WAREHOUSE_LOAD_SUCCESS, WAREHOUSE_LOAD_FAIL} from './driverTypes.js';
import { PARCEL_RETURN_REFERENCE_LOAD, PARCEL_RETURN_REFERENCE_LOAD_SUCCESS, PARCEL_RETURN_REFERENCE_LOAD_FAIL} from './driverTypes.js';
import { ADD_PARCEL_RETURN, ADD_PARCEL_RETURN_SUCCESS, ADD_PARCEL_RETURN_FAIL} from './driverTypes.js';

export function getWarehouseInfo() {
    return function(dispatch) {
        dispatch({type: WAREHOUSE_LOAD})
        return adminServerInstance.get(`map/getbasicinfo`)  
        .then(({data}) => {
            if (data.status === "SUCCESS") {
                dispatch({
                    type: WAREHOUSE_LOAD_SUCCESS,
                    payload: data,
                })    
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: WAREHOUSE_LOAD_FAIL,
                    payload: data.data,
                })   
                return Promise.reject(data); 
            }
        });
    }
}

export function getParcelReturnReference(warehouse) {
    return function(dispatch) {
        dispatch({type: PARCEL_RETURN_REFERENCE_LOAD})
        return adminServerInstance.get(`map/getreturnparcelreferencenum?warehouse=${warehouse}`)  
        .then(({data}) => {
            if (data.status === "SUCCESS") {
                dispatch({
                    type: PARCEL_RETURN_REFERENCE_LOAD_SUCCESS,
                    payload: data,
                })    
                return Promise.resolve(data);
            } else {
                dispatch({
                    type: PARCEL_RETURN_REFERENCE_LOAD_FAIL,
                    payload: data,
                })    
                return Promise.reject(data);
            }
        });
    }
}

/**
 * @param {Object} params
 * @param {string} params.fedex_tno // Optional
 * @param {string} params.scan_location
 * @param {string} params.warehouse
 * @param {string} params.batch_no
 * @param {string} params.tnos
 * @param {string} params.storage_info
 * @param {string} params.operator
 * @param {Number} params.add_on // 0
 * @param {Number} params.local_import // 0
 * @param {Number} params.is_scanned // 1
 * @param {Number} params.is_return_scanned // 1
 * @param {Number} params.version // 0
 */
export function addParcelReturn(params) {
    return function(dispatch) {
        dispatch({type: ADD_PARCEL_RETURN})
        return adminServerInstance.post(`business/addreturnedpackage`,params)  
        .then(({data}) => {
                dispatch({
                    type: ADD_PARCEL_RETURN_SUCCESS,
                    payload: data,
                })    
                return Promise.resolve(data);
            }).catch(error => {
                dispatch({
                    type: ADD_PARCEL_RETURN_FAIL,
                    payload: error,
                })    
                return Promise.reject(error);
        })
    }
}
